const discover = "/discover";
const textProps = {
  title: "",
  description:
    "",
  copyright:
    "Copyright © " + new Date().getFullYear() + " Svegile Technologies Private Limited.",
  /*socials: [
    {
      icon: "twitter",
      link: "https://twitter.com/svegile",
    },
    {
      icon: "facebook",
      link: "https://www.facebook.com/people/Svegile-Technologies/100088284262886/",
    },
    {
      icon: "youtube",
      link: "https://www.youtube.com/channel/UCwbCnqx10hwWb8TsF300W7w",
    },
    {
      icon: "linkedin",
      link: "https://www.linkedin.com/in/svegile-technologies/",
    },
  ],*/
  links: [
    {
      name: "Services",
      items: [
        { href: "/services/software-development", children: "Software Development", },
        { href: "/services/web-development", children: "Web Development" },
        { href: "/services/mobile-development", children: "Mobile Development" },
        { href: "/services/enterprise-development", children: "Enterprise Operations" },
        { href: "/services/quality-assurance", children: "Quality Assurance" },
        { href: "/services/devops-cloud", children: "DevOps and Cloud engineering" },
        { href: "/services/dedicated-dev-team", children: "Dedicated Development Team" },
        { href: "/services/startup-development", children: "Startup development" },
      ],
    },
    {
      name: "Discover",
      items: [
        {
          href: discover,
          children: "Engagement",
        },
        {
          href: discover,
          children: "Technologies",
        },
      ],
    },
    {
      name: "Navigation",
      items: [
        {
          href: "resources",
          children: "Resources",
        },
        {
          href: "careers",
          children: "Careers",
        },
        {
          href: "aboutus",
          children: "About Us",
        },
        {
          href: "pilot",
          children: "Request for pilot",
        },
      ],
    },
    {
      name: "Legal",
      items: [
        {
          href: "privacypolicy",
          children: "Privacy Policy",
        },
      ],
    },
  ],
};
export default textProps;
